'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DrawerProvider: function() {
        return DrawerProvider;
    },
    drawerContext: function() {
        return drawerContext;
    },
    useDrawerContextValue: function() {
        return useDrawerContextValue;
    },
    useDrawerContext_unstable: function() {
        return useDrawerContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const defaultContextValue = {
    scrollState: 'none',
    setScrollState: ()=>({})
};
const drawerContext = /*#__PURE__*/ _react.createContext(undefined);
const DrawerProvider = drawerContext.Provider;
const useDrawerContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(drawerContext)) !== null && _React_useContext !== void 0 ? _React_useContext : defaultContextValue;
};
const useDrawerContextValue = ()=>{
    const [scrollState, setScrollState] = _react.useState('none');
    return {
        setScrollState,
        scrollState
    };
};
